module.exports = __webpack_public_path__ + "img/edit-pen.d8a4ff5a.svg";